export const HERO_IMAGE = {
  x1: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/hero_1x.png',
  x2: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/hero_2x.png',
};

export const CONSULTATION_BLOCK = {
  x1: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/call_me_x1.png',
  x2: 'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/call_me_x2.png',
};

export const CONSULTATION_REQUEST_MODAL_IMAGE =
  'https://cdn.cian.site/frontend/e2e-form-assets/partner_rewards/other/call-me.png';

export const ABOUT_DEAL_IMAGE = 'https://cdn.cian.site/frontend/e2e-form-assets/promo/images/video_card_background.png';

export const HOW_IT_WORKS_PREVIEW =
  'https://cdn.cian.site/frontend/e2e-form-assets/promo/videos/preview/howItWorksPreview.png';
